import { useContext, useEffect, useState } from "react";
import { StatementContext } from "utils/context/StatementsContext";

const useRoles = (type, documentType, senderNumber) => {
    const { roles } = useContext(StatementContext)

    const [hasOverviewReportAccess, setHasOverviewReportAccess] = useState(false)
    const [hasAnalysisReportAccess, setHasAnalysisReportAccess] = useState(false)

    const handleAccessToOverviewReport = () => {
        if (type === 'sender') {
            setHasOverviewReportAccess(true)
            return;
        }

        if (roles.filter(x => 
                    x.type === documentType 
                &&  (!senderNumber ||  x.senderNumber === senderNumber) 
                && x.atomicOperations.indexOf('DISPLAY_PO_OVERVIEW') > -1).length) {
            setHasOverviewReportAccess(true)
            return;
        }

        setHasOverviewReportAccess(false)
    }

    const handleAccessToAnalysisReport = () => {
        if (type === 'sender') {
            setHasAnalysisReportAccess(true)
            return;
        }

        if (roles.filter(x => 
                    x.type === documentType 
                &&  (!senderNumber || x.senderNumber === senderNumber) 
                && x.atomicOperations.indexOf('DISPLAY_PO_ANALYSIS') > -1).length) {
                setHasAnalysisReportAccess(true)
            return;
        }

        setHasAnalysisReportAccess(false)
    }

    useEffect(() => {
        if (!roles.length) return;
        
        handleAccessToOverviewReport()
        handleAccessToAnalysisReport()

    }, [roles, documentType, senderNumber])

    return {
        hasOverviewReportAccess,
        hasAnalysisReportAccess
    }
}

export default useRoles;